// extracted by mini-css-extract-plugin
module.exports = {"kitK":"kitK_kitK__XbI9P"};